import { useQuery, UseQueryResult } from '@tanstack/react-query'
import { gql } from 'graphql-request'

import { useGraphQLClient } from '@/hooks/useGraphQLClient'

export interface User {
  activeShipments: number
  email: string
  firstName: string
  id: string
  lastName: string
  mobileVerificationEligible: boolean
  mobileVerified: boolean
  phoneNumber: string
  complete: boolean
  countryCode: string
}

const FIVE_MINUTES = 5 * 60 * 1000

const GET_CURRENT_USER = gql`
  query GetCurrentUser {
    user {
      activeShipments
      email
      firstName
      id
      lastName
      mobileVerificationEligible
      mobileVerified
      phoneNumber
      complete
      countryCode
    }
  }
`

/**
 * Hook to fetch the current authenticated user.
 * Throws if unauthorized.
 */
export function useUserApi(enabled: boolean): UseQueryResult<User, Error> {
  const client = useGraphQLClient()

  return useQuery<User, Error>({
    queryKey: ['currentUser'],
    queryFn: async () => {
      const { user } = await client.request<{ user: User }>(GET_CURRENT_USER)

      if (!user) throw new Error('Unauthorized')

      return user
    },
    enabled,
    staleTime: FIVE_MINUTES,
    gcTime: FIVE_MINUTES,
  })
}
